export default __webpack_public_path__ + "static/media/china.d05a649b.svg";